import { Fragment, ReactNode } from 'react';
import { Link } from 'react-router-dom';

type BreadcrumbLink = {
  label: string;
  startAdornment?: ReactNode;
  to?: string;
};

type Props = {
  links: BreadcrumbLink[];
  /**
   * Typography style for breadcrumb text.
   * Use 'type-heading2' for new implementations (recommended).
   * 'type-body1' is provided for legacy usage.
   * @default 'type-body1'
   */
  typography?: 'type-body1' | 'type-heading2';
};

const Breadcrumbs = ({ links, typography = 'type-body1' }: Props) => {
  return (
    <div className={`flex min-w-0 items-center gap-1 ${typography}`}>
      {links.map((link, index) => {
        const isLast = index === links.length - 1;
        const className = [
          'overflow-hidden align-middle flex gap-1 items-center',
          isLast ? '' : 'w-max shrink-0',
          link.to ? 'link' : '',
        ].join(' ');

        return (
          <Fragment key={link.label}>
            {/* display a link or div based on the presence of `to` */}
            {link.to ? (
              <Link className={className} data-cy="breadcrumbs-link" to={link.to}>
                {link.startAdornment}
                <span className="truncate">{link.label}</span>
              </Link>
            ) : (
              <div className={className} data-cy="breadcrumbs-text">
                {link.startAdornment}
                <span className="truncate">{link.label}</span>
              </div>
            )}
            {/* conditionally add a separator */}
            {!isLast && '/'}
          </Fragment>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
